/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
namespace dvs_ui {

   export class DvsEditPvlanDialogConstants {
      public static readonly ADD: string = "add-action";
      public static readonly REMOVE: string = "remove-action";
      public static readonly PVLAN_ID_VALUE_MIN: number = 1;
      public static readonly PVLAN_ID_VALUE_MAX: number = 4094;
   }
}